import { startCase as _startCase } from 'lodash';
import moment from 'moment';

import { DATE_FORMAT, MONTH_YEAR_FORMAT, TIME_FORMAT } from './constants';

// extended from lodash so FOO BAR can be Foo Bar (lodash would keep it all uppercase), and roman numerals will be capitalized
export function startCase(value: string | null | undefined) {
  return value
    ? _startCase(
        value.toLowerCase().replace(/(\s+|^)([mdclxvi]+)(\s+|\n|$)/, match => match.toUpperCase())
      ) // keeps roman numerals capitalized
    : null;
}

export function formatDate(value: moment.MomentInput) {
  return value ? moment(value).format(DATE_FORMAT) : null;
}

export function formatUnixTimestamp(value: number) {
  return value ? moment.unix(value).format(DATE_FORMAT) : null;
}

export function formatTime(value: moment.MomentInput) {
  return value ? moment(value).format(TIME_FORMAT) : null;
}

// Numeric rather than "Aug 2027": month names would render in English for all
// six languages, and dates in this app stay locale-neutral (see docs/i18n.md).
export function formatMonthYear(value: moment.MomentInput) {
  return value ? moment(value).format(MONTH_YEAR_FORMAT) : null;
}

/** Formats a byte count for display (binary units: 1 KB = 1024 B). */
export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) {
    return '';
  }

  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let size = bytes;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex += 1;
  }

  if (unitIndex === 0) {
    return `${Math.round(size)} ${units[unitIndex]}`;
  }

  // Two decimals, then drop trailing zeros. Promote if rounding hits the next unit.
  size = Number(size.toFixed(2));
  if (size >= 1024 && unitIndex < units.length - 1) {
    size = Number((size / 1024).toFixed(2));
    unitIndex += 1;
  }

  return `${size} ${units[unitIndex]}`;
}
